<template>
  <div class="guarantee">
    <main-guarantee-item :guarantee-text="guaranteeText" />
  </div>
</template>

<script>
import MainGuaranteeItem from "@/components/main/mainSlide/modules/MainGuaranteeItem.vue";

export default {
  name: "main-guarantee-block",
  components: {
    MainGuaranteeItem,
  },
  props: {
    guaranteeText: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.guarantee {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;

  @media (max-width: 767px) {
    gap: 16px;
  }
}
</style>
